import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';


export const Wrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.01) 100%);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.30);
  backdrop-filter: blur(25px);
  padding: 32px;
  gap: 30px;
  width: 389px;

  @media (max-width: 850px) {
    width: 100%;
  }
`;

export const Description = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  span {
    color: #FE5A83
  }
`;

export const Image = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 100%;
  ${mediaQuery.maxWidth.tablet} {
    height: 100%;
  }
`;

export const SocialWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SocialTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SocialName = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 16px;
`;

export const SocialUsername = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 14px;
`;